import EmailAuthLinkResolver from './EmailAuthLinkResolver';

export default EmailAuthLinkResolver;
